import { useTrans } from 'hooks'
import React, { useContext } from 'react'
import { Cart } from 'react-components/atoms/Icons'
import { CartContext } from 'utils/context'

const HeaderCart = props => {
  const { className = '', href = '' } = props

  const { cart, openCart } = useContext(CartContext)
  const t = useTrans()

  return href ? (
    <a aria-label={t("Carrello")} className={`header-cart ${className ? ` ${className}` : ''}`} href={href}>
      <Cart />
      {!!cart?.numProdotti && <span className="header-cart__badge">{cart?.numProdotti}</span>}
    </a>
  ) : (
    <button type="button" aria-label={t("Apri carrello")} className={`header-cart ${className ? ` ${className}` : ''}`} onClick={openCart}>
      <Cart />
      {!!cart?.numProdotti && <span className="header-cart__badge">{cart?.numProdotti}</span>}
    </button>
  )
}

export default HeaderCart
